
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-black to-gray-900 text-white pt-12 sm:pt-16 pb-6 sm:pb-8 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start gap-12 lg:gap-16 mb-8 sm:mb-12 text-center">
          <div className="flex flex-col items-center">
            <img
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/cbc12e6e2441c5ee6f286cff30459b30.png"
              alt="Up N' Smoke"
              className="h-12 sm:h-14 lg:h-16 mb-3 sm:mb-4"
            />
            <p className="text-gray-300 font-rajdhani text-sm leading-relaxed max-w-xs">
              Your premier destination for vape accessories, themed apparel, and unique decals in Elkhart, Indiana.
            </p>
          </div>

          <div className="flex flex-col items-center">
            <h3 className="font-orbitron text-base sm:text-lg font-bold text-neon-purple mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-2 font-rajdhani text-sm sm:text-base">
              <li>
                <Link to="/" className="text-gray-300 hover:text-neon-purple transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/accessories" className="text-gray-300 hover:text-neon-purple transition-colors">
                  Accessories
                </Link>
              </li>
              <li>
                <Link to="/shirts" className="text-gray-300 hover:text-neon-purple transition-colors">
                  Shirts
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-300 hover:text-neon-purple transition-colors">
                  Hats
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-neon-purple transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center">
            <h3 className="font-orbitron text-base sm:text-lg font-bold text-neon-purple mb-3 sm:mb-4">Contact Info</h3>
            <ul className="space-y-3 font-rajdhani text-sm sm:text-base text-gray-300">
              <li className="flex flex-col items-center">
                <i className="ri-map-pin-line text-neon-pink mb-1"></i>
                <span className="text-center">3227 Northview Dr<br />Elkhart, IN 46514</span>
              </li>
              <li className="flex flex-col items-center">
                <i className="ri-phone-line text-neon-pink mb-1"></i>
                <a href="tel:5742187357" className="hover:text-neon-purple transition-colors">
                  (574) 218-7357
                </a>
              </li>
              <li className="flex flex-col items-center">
                <i className="ri-mail-line text-neon-pink mb-1"></i>
                <a href="mailto:upnsmokevapes@gmail.com" className="hover:text-neon-purple transition-colors">
                  upnsmokevapes@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center">
            <h3 className="font-orbitron text-base sm:text-lg font-bold text-neon-purple mb-3 sm:mb-4">Follow Us</h3>
            <div className="flex space-x-3 sm:space-x-4 mb-4 sm:mb-6">
              <a
                href="https://www.facebook.com/people/Up-N-Smoke-Vape-Shop/61584660412472/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
            <div className="bg-white p-2 sm:p-3 rounded-lg inline-block">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://www.facebook.com/people/Up-N-Smoke-Vape-Shop/61584660412472/"
                alt="Facebook QR Code"
                className="w-16 h-16 sm:w-20 sm:h-20"
              />
              <p className="text-xs text-center text-black mt-1 font-rajdhani">Scan to Follow</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 sm:pt-8 text-center">
          <p className="text-gray-400 font-rajdhani text-xs sm:text-sm px-4 flex items-center justify-center gap-2 flex-wrap">
            <span>© {new Date().getFullYear()} Up N' Smoke. All rights reserved.</span>
            <span>|</span>
            <a
              href="https://meltgraphicsprint.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-neon-purple hover:text-neon-pink transition-colors"
            >
              <img
                src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/c095d581dc1845a3b1c3b759951a8d5b.png"
                alt="Melt Graphics"
                className="h-5 sm:h-6"
              />
              <span className="whitespace-nowrap">Powered by Melt Graphics</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
